import Splide from "@splidejs/splide";


class MediaGallery extends HTMLElement {
    constructor() {
        super();

        this.generateSplides();
    }

    generateSplides() {
        const thumbnailSplideObject = this.querySelector(".media-gallery__splide-thumbnails")?.getAttribute("data-splide");
        const previewSplideObject = this.querySelector(".media-gallery__splide-preview")?.getAttribute("data-splide");

        const thumbnailSplideObjectData = thumbnailSplideObject ? JSON.parse(thumbnailSplideObject) : {};
        const previewSplideObjectData = previewSplideObject ? JSON.parse(previewSplideObject) : {};

        const thumbnailSplide = new Splide(".media-gallery__splide-thumbnails", thumbnailSplideObjectData);
        const previewSplide = new Splide(".media-gallery__splide-preview", previewSplideObjectData);
    
        previewSplide.sync(thumbnailSplide);
        // const videoSlide = previewSplide.root.querySelector("deferred-media");
        const reference = this;
        previewSplide.on('moved', function(newIndex, oldIndex, destIndex) {
            window.pauseAllMedia();
            const currentSlide = previewSplide.Components.Elements.slides[previewSplide.index];
            if(currentSlide.querySelector('deferred-media') != null) {
                currentSlide.querySelector('deferred-media')?.loadContent(false);
            }
        })
        previewSplide.mount();
        thumbnailSplide.mount();
    }
}


customElements.define("media-gallery", MediaGallery);

